var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3594 24.0625H30.625V7.46826L34.6794 3.41387C35.1066 2.98662 35.1066 2.29414 34.6794 1.86689L33.1331 0.320605C32.7059 -0.106641 32.0134 -0.106641 31.5861 0.320605L27.5317 4.375H13.125V10.9375H20.9692L10.9375 20.9692V1.64062C10.9375 0.73418 10.2026 0 9.29688 0H6.01562C5.10986 0 4.375 0.73418 4.375 1.64062V4.375H1.64062C0.734863 4.375 0 5.10918 0 6.01562V9.29688C0 10.2026 0.734863 10.9375 1.64062 10.9375H4.375V28.9844C4.375 29.8901 5.10986 30.625 6.01562 30.625H21.875V24.0625H14.0308L24.0625 14.0308V33.3594C24.0625 34.2651 24.7974 35 25.7031 35H28.9844C29.8901 35 30.625 34.2651 30.625 33.3594V30.625H33.3594C34.2651 30.625 35 29.8901 35 28.9844V25.7031C35 24.7967 34.2651 24.0625 33.3594 24.0625Z",
    fill: "url(#paint0_linear_2100_9508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2100_9508",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiux);
export default __webpack_public_path__ + "static/media/uiux.85dc89e9337f28dbb3d2dd21b9b08fa3.svg";
export { ForwardRef as ReactComponent };